import React from 'react'
import get from 'lodash/get'
import find from 'lodash/find'
import concat from 'lodash/concat'
import isNil from 'lodash/isNil'
import findIndex from 'lodash/findIndex'
import isNumber from 'lodash/isNumber'
import isFunction from 'lodash/isFunction'
import { List } from 'immutable'
import { getAuthIsLoggedIn } from 'services/auth'
import { connect as connectRedux } from 'react-redux'
import {
  getCampaign, getVariation, getSubject, variationShouldRender,
} from 'services/testarossa'
import TestarossaDefault from '../TestarossaDefault'
import TestarossaCase from '../TestarossaCase'

function variationIsMatch (variation, ids, notVariation) {
  const friendlyId = get(variation, 'friendlyId')
  if (!isNil(ids)) {
    const variationIds = concat([], ids)
    const match = find(variationIds, (id) => {
      return id === friendlyId
    })
    return isNumber(match)
  } if (!isNil(notVariation)) {
    const notVariationIds = concat([], notVariation)
    const match = find(notVariationIds, (id) => {
      return id === friendlyId
    })
    return !isNumber(match)
  }
  return true
}

function getChildren (props) {
  return concat([], props.children || [])
}

function getDefault (children) {
  return findIndex(children, (c) => (
    c && c.type === TestarossaDefault
  ))
}

function pickChild (children) {
  const index = findIndex(children, (child) => {
    const { type, props } = child
    const {
      campaign: id, variation: vids, notVariation, condition,
    } = props
    if (type === TestarossaCase) {
      const campaign = getCampaign({ id })
      const subject = getSubject({ campaign })
      const variation = getVariation({ campaign })

      if (variationIsMatch(variation, vids, notVariation)
        && variationShouldRender({ campaign, variation, subject })) {
        const conditionWasMet = isFunction(condition)
          ? !!condition(campaign, variation, subject) : true
        return conditionWasMet
      }
    } else if (type === TestarossaSwitch) {
      return pickChild(getChildren(props))
    }
    return false
  })
  if (index < 0) {
    return getDefault(children)
  }
  return index
}

function getInitialState (props) {
  const { bootstrapComplete, initialized } = props
  const children = getChildren(props)
  if (bootstrapComplete && initialized) {
    return {
      index: pickChild(children),
      ready: true,
    }
  }
  const index = getDefault(children)
  return { index, ready: false }
}

class TestarossaSwitch extends React.Component {
  constructor (props) {
    super(props)
    this.state = getInitialState(props)
  }

  componentDidMount () {
    const { state, props } = this
    const { initialized, isLoggedIn } = props
    const { ready } = state
    if (isLoggedIn && ready !== true && initialized) {
      const children = getChildren(props)
      const index = pickChild(children)
      // solves an ssr -> csr issue
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState(() => ({
        ready: true,
        index,
      }))
    }

    if (!isLoggedIn) {
      const index = getDefault(getChildren(props))
      this.setState(() => ({
        ready: true,
        index,
      }))
    }
  }

  componentDidUpdate (prevProps) {
    const { records: prevRecords, context: prevContext } = prevProps
    const {
      records,
      context,
      failure,
      initialized,
      isLoggedIn,
    } = this.props

    if (!isLoggedIn) {
      return
    }

    if (!initialized) {
      return
    }

    if (failure) {
      const index = getDefault(getChildren(this.props))
      this.setState(() => ({
        ready: true,
        index,
      }))
    }

    if (records !== prevRecords || context !== prevContext) {
      const index = pickChild(getChildren(this.props))
      this.setState(() => ({
        ready: true,
        index,
      }))
    }
  }

  render () {
    const { state, props } = this
    const { index } = state
    const { isLoggedIn, initialized, records } = props
    const children = getChildren(props)

    if (isLoggedIn && !initialized) {
      return null
    }

    if (isLoggedIn && !List.isList(records)) {
      return null
    }

    return children[index] || null
  }
}

const connectedTestarossaSwitch = connectRedux((state) => {
  const { testarossa, app, auth } = state
  const records = testarossa.get('records')
  const context = testarossa.get('context')
  const failure = testarossa.get('failure')
  const bootstrapComplete = app.get('bootstrapComplete')
  const isLoggedIn = getAuthIsLoggedIn(auth)
  const initialized = testarossa.get('initialized')

  return {
    records, context, failure, bootstrapComplete, isLoggedIn, initialized,
  }
})(TestarossaSwitch)

export default connectedTestarossaSwitch
